import { RadialGradient } from '@jouzen/ecom-components';

import LandingPageHero from '@/app/components/LandingPage/LandingPageHero';

const BackgroundOverlay = () => (
  <div className="absolute top-0 size-full">
    <div className="absolute top-0 size-full lg:hidden">
      <RadialGradient
        className="scale-x-150"
        hex="#452B1D"
        id="mobile-gradient-1"
        opacity={0.6}
        position={[50, 0]}
        size={50}
        shape="circle"
      />
      <RadialGradient
        className="scale-x-150"
        hex="#402518"
        id="mobile-gradient-2"
        opacity={0.8}
        position={[50, 100]}
        size={50}
        shape="circle"
      />
    </div>
    <div className="absolute top-0 size-full max-lg:hidden">
      <RadialGradient
        hex="#321F16"
        id="desktop-gradient-1"
        opacity={0.2}
        position={[20, 50]}
        size={100}
        shape="circle"
      />
      <RadialGradient
        hex="#321F16"
        id="desktop-gradient-2"
        opacity={0.2}
        position={[0, 50]}
        size={100}
        shape="circle"
      />
      <div
        className="absolute top-0 h-1/2 w-full opacity-40 bg-blend-multiply"
        style={{
          backgroundImage:
            'linear-gradient(0deg, transparent 0%, #151619 100%)',
        }}
      />
    </div>
  </div>
);

const WhyOuraHeroOR4 = () => {
  return (
    <LandingPageHero
      backgroundImage={{
        alt: '',
        srcSet: [
          {
            media: '(max-width: 1023px)',
            src: '/blue-sky/why-oura/why-oura-hero-10-24.jpg?ar=1:1&fit=crop&crop=focalpoint&fp-x=0.5&fp-y=0.5&fp-z=1&flip=h',
          },
          {
            media: '(min-width: 1024px)',
            src: '/blue-sky/why-oura/why-oura-hero-10-24.jpg?ar=5:4&fit=crop&crop=focalpoint&fp-x=0.55&fp-y=0.5&fp-z=1.1&flip=h',
          },
        ],
      }}
      backgroundOverlay={<BackgroundOverlay />}
      backgroundProps={{
        color: 'sandstone-400',
        gradients: [],
      }}
      copy="why_oura_hero_subtitle"
      data-cy="why-oura-hero-or4"
      eyebrow="why_oura_link"
      eyebrowProps={{
        className: 'max-lg:hidden',
      }}
      title="why_oura_hero_title"
      titleProps={{
        indentation: 'pl-[10rem] md:pl-[15rem] lg:pl-[20rem]',
        typographyProps: {
          className: 'lg:en:whitespace-nowrap',
        },
      }}
      textColor="text-sandstone-200"
    />
  );
};

export default WhyOuraHeroOR4;
